import * as React from "react";
import { cn } from "../../lib/utils";

const BAR_MAP = {
  emerald: "bg-emerald-500",
  amber: "bg-amber-500",
  red: "bg-rose-500",
  indigo: "bg-indigo-500",
  sky: "bg-sky-500",
  slate: "bg-slate-500",
};

const TRACK_MAP = {
  emerald: "bg-emerald-100/70",
  amber: "bg-amber-100/70",
  red: "bg-rose-100/70",
  indigo: "bg-indigo-100/70",
  sky: "bg-sky-100/70",
  slate: "bg-slate-200/70",
};

const Progress = React.forwardRef(
  ({ className, value = 0, status = "indigo", overrideBarColor, overrideTrackColor, ...props }, ref) => {
    const v = Math.max(0, Math.min(100, Number(value) || 0));
    const bar = overrideBarColor ? null : (BAR_MAP[status] || BAR_MAP.indigo);
    const track = overrideTrackColor ? null : (TRACK_MAP[status] || TRACK_MAP.slate);
    return (
      <div
        ref={ref}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={v}
        className={cn("relative h-2 w-full overflow-hidden rounded-full", track, className)}
        style={overrideTrackColor ? { backgroundColor: overrideTrackColor } : undefined}
        {...props}
      >
        <div
          className={cn("h-full w-full flex-1 transition-all", bar)}
          style={{
            transform: `translateX(-${100 - v}%)`,
            ...(overrideBarColor ? { backgroundColor: overrideBarColor } : {})
          }}
        />
      </div>
    );
  }
);
Progress.displayName = "Progress";

export { Progress };
